"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ThreadList = _interopRequireDefault(require("../ThreadList"));
var _Container = _interopRequireDefault(require("./Container"));
require("./index.css");
var _default = exports["default"] = function _default(_ref) {
  var total = _ref.total,
    renderItem = _ref.renderItem,
    left = _ref.left,
    right = _ref.right;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    className: "flex flex-col",
    left: left,
    right: right
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-light py-4"
  }, total, " message", total > 1 ? 's' : '', " found"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative h-full"
  }, /*#__PURE__*/_react["default"].createElement(_ThreadList["default"], {
    total: total,
    renderItem: renderItem,
    isLoaded: function isLoaded() {
      return true;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute bottom-0 w-full h-24 overlay-gradient"
  })));
};
//# sourceMappingURL=ThreadListPreview.js.map